import { useInView } from 'framer-motion';
import { useEffect, useRef } from 'react';
export var useCloseWhenOutsideViewport = function useCloseWhenOutsideViewport(_ref) {
  var callback = _ref.callback,
    isActive = _ref.isActive,
    tooltipRef = _ref.tooltipRef;
  var isPositioned = useRef(false);
  var isInView = useInView(tooltipRef);
  useEffect(function () {
    if (isInView || !tooltipRef.current) {
      isPositioned.current = true;
      return;
    }
    if (isPositioned.current && isActive) {
      callback === null || callback === void 0 ? void 0 : callback(undefined, 'viewport');
    }
  }, [isInView, isActive]);
};